import React, { useEffect, useState } from "react";
import { Avatar, Box, Chip, Grid, SvgIcon, Typography, Button, Tabs, Tab, IconButton, ButtonGroup, Popper, Grow, Paper, MenuItem, MenuList, TextField, Autocomplete, TablePagination } from "@mui/material";

import CommentBox from "view/test/CommentBox";
import CommentList from "view/test/CommentList";


const Comments = () => {

    return (
        <>
            <Grid container spacing={2} sx={{ mt: '20px' }}>
                <Grid size={12}>
                    <Typography variant="h5" sx={{ mb: 1 }}>
                        Action Tracker Comment
                    </Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <CommentList />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <CommentBox />
                </Grid>
                
            </Grid>
        </>
    );
}

export default Comments;